"use client";

import { Link } from "@mui/material";

interface ExternalLinkProps {
  href: string;
  children: React.ReactNode;
}

export const ExternalLink = ({ href, children }: ExternalLinkProps) => {
  return (
    <Link
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        color: "inherit",
        textDecoration: "underline",
      }}
    >
      {children}
    </Link>
  );
};
